import { Button, CloseIcon, Drawer, Radio, Text } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import styles from './drawer-filter.module.css'

import { DrawerFilterProps } from './drawer-filter.type'

export const SupplyTransactionDrawerFilter = ({
  isOpen,
  onHandleOpen,
  filter,
  onHandleFilter,
}: DrawerFilterProps) => {
  const { t } = useTranslation('screenSupplierOrderManagementPage')

  const onChangeBooleanOfSingleValue = (key: string, value: string) => {
    onHandleFilter({ ...filter, [key]: value })
  }

  const getBooleanOfSingleValue = (key: string, value: string): boolean => {
    return filter[key] === value
  }

  return (
    <Drawer isOpen={isOpen} onHandleOpen={onHandleOpen}>
      <div className={styles.header}>
        <Text variant="title-large" className={styles['header-title']}>
          {t('drawerFilterTitle')}
        </Text>

        <button
          className={styles['header-button']}
          type="button"
          onClick={onHandleOpen}
        >
          <CloseIcon />
        </button>
      </div>

      <div className={styles.content}>
        <div className={styles['content-filter']}>
          <Text variant="title-base">
            {t('tableSupplyTransactionDrawerFilterCurrency')}
          </Text>
          <div className={styles['content-filter-row']}>
            <Radio
              value={getBooleanOfSingleValue('currency', '')}
              onChange={() => onChangeBooleanOfSingleValue('currency', '')}
            >
              {t('tableSupplyTransactionDrawerFilterCurrencyAll')}
            </Radio>
            <Radio
              value={getBooleanOfSingleValue('currency', 'MXN')}
              onChange={() => onChangeBooleanOfSingleValue('currency', 'MXN')}
            >
              MXN
            </Radio>
            <Radio
              value={getBooleanOfSingleValue('currency', 'USD')}
              onChange={() => onChangeBooleanOfSingleValue('currency', 'USD')}
            >
              USD
            </Radio>
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <Button variant="secondary" onClick={onHandleOpen}>
          {t('drawerFilterButtonBack')}
        </Button>
      </div>
    </Drawer>
  )
}
